/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ mode: NonNullable<unknown> }} Ui_Color_By_Compact_LabelInputs */

const en_ui_color_by_compact_label = /** @type {(inputs: Ui_Color_By_Compact_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Color by: ${i?.mode}`)
};

const de_ui_color_by_compact_label = /** @type {(inputs: Ui_Color_By_Compact_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Färben nach: ${i?.mode}`)
};

/**
* | output |
* | --- |
* | "Color by: {mode}" |
*
* @param {Ui_Color_By_Compact_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_compact_label = /** @type {((inputs: Ui_Color_By_Compact_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Compact_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_compact_label(inputs)
	return de_ui_color_by_compact_label(inputs)
});